import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=e1e8796c&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/janpencik/Sites/events/wp-content/plugins/event-feed-for-eventbrite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1e8796c')) {
      api.createRecord('e1e8796c', component.options)
    } else {
      api.reload('e1e8796c', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=e1e8796c&", function () {
      api.rerender('e1e8796c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/src/js/components/Widget.vue"
export default component.exports